import React from 'react';

const ActionButton: React.FC<ActionButtonProps> = ({
    children,
    type = 'submit',
    color = 'green',
    icon,
    isPosting = false,
    disabled = false,
    onClick = () => {},
    extraClasses = '',
    isWebArea = false,
}) => (
    <button
        className={`${!isWebArea ? 'button' : 'btn'} ${color} ${
            disabled ? 'disabled' : ''
        } ${extraClasses}`}
        type={type}
        disabled={isPosting || disabled}
        onClick={onClick}
    >
        {icon && !isPosting && (
            <i className={`${isWebArea ? 'button-icon' : 'icon'} far fa-fw fa-${icon}`}></i>
        )}
        {isPosting && (
            <i
                className={`${isWebArea ? 'button-icon' : 'icon'}  far fa-fw fa-spinner fa-spin`}
            ></i>
        )}
        <span className={!isWebArea ? 'text' : ''}>{children}</span>
    </button>
);

interface ActionButtonProps {
    children?: React.ReactNode;
    extraClasses?: string;
    type?: 'submit' | 'button' | 'reset';
    color?: string;
    icon?: string;
    isPosting?: boolean;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    disabled?: boolean;
    isWebArea?: boolean;
}

export default ActionButton;
